
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/protection-plans/[category_slug]",
      function () {
        return require("private-next-pages/protection-plans/[category_slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/protection-plans/[category_slug]"])
      });
    }
  